<template>
	<div class="list-group border-radius-2 no-border mb-4">
		<WidgetHeader link="/clinical?hasstudentfeedback=false">{{ $t('sessions-without-your-feedback') }}</WidgetHeader>

		<div
			v-for="(item, i) in items"
			:item="item"
			:key="i" @click="selectTreatmentSession(item)"
			class="list-group-item"
		>
			<p class="mb-1 mt-1 font-bold">
				{{ $t("id-colon") }} {{ item.id }}

				<span
					class="badge badge-pill badge-secondary mr-1 ml-1 mb-1"
					v-if="!item.isLocked">
						{{ $t("not-marked") }}
				</span>
				<span class="badge badge-pill badge-success mr-1 ml-1 mb-1" v-if="item.isLocked">
					{{ $t("marked") }}
				</span>
				<span
					class="badge badge-pill badge-danger mr-1 ml-1 mb-1"
					v-if="Number(item.patientAttendance) >= 2">
					{{ $t("patient-did-not-attend") }}
				</span>
				<span
					class="badge badge-pill badge-success mr-1 ml-1 mb-1"
					v-if="item.hasPatientFeedback">
					{{ $t("patient-feedback") }}
				</span>
			</p>

			<ul class="list-bare" style="overflow: hidden">
				<template v-for="participationType in $config.getValue('participationTypes')">
					<li
						class="mr-3 float-lg-left text-sm"
						v-bind:key="participationType.id"
						v-if="participationType.id == item.typeId"
					>
						{{ participationType.name }}
					</li>
				</template>
				<li class="mr-3 float-lg-left text-sm">{{ item.clinicName }}</li>
				<li class="mr-3 float-lg-left text-sm">
					{{ $datetime.getLocaleStringFromTimeStamp(item.treatmentTimestamp) }}
				</li>
				<li class="mr-3 float-lg-left text-sm">
					{{ $t("teacher-colon") }} {{ item.teacher_displayname }}
				</li>
			</ul>
		</div>

		<template v-if="loading">

			<div class="list-group-item" v-for="i in 3" :key="i">

				<div class="avatar float-left mr-4 mb-3 lg:mb-0 skeleton"></div>
				<div class="float-left">
					<div class="skeleton midnight h20 w200 mb-3"></div>
					<div>
						<div class="skeleton midnight h20 w50 mr-4 float-left"></div>
						<div class="skeleton midnight h20 w50 mr-4 float-left"></div>
						<div class="skeleton midnight h20 w50 mr-4 float-left"></div>
						<div class="skeleton midnight h20 w50 mr-4 float-left"></div>
					</div>
				</div>
			</div>

		</template>

	</div>
</template>

<script>
import WidgetHeader from "./WidgetHeader";

export default {
	props: ['limit'],
	components: {
		WidgetHeader
	},
	data() {
		return {
			items: [],
			loading: true
		}
	},
	methods: {
		getitems(limit) {
			const data = {
				limit ,
				isLocked: 'true',
				hasstudentfeedback: 'false',
				orderBy: 'datelocked'
			}
			this.$cfetch(`${this.$settings.APIBaseURL}/treatmentsessions/list`, {
				data
			}).then((res) => {
				if (res.status === "SUCCESS") {
					this.loading = false;
					this.items = res.treatmentsessions;
				}
			})
		},
		selectTreatmentSession(item) {
			this.$store.commit("showBlockingSpinner");
			this.$router.push(`/clinical/treatmentsession/${item.id}/marking`);
		}
	},
	mounted() {
		this.getitems(this.limit);
	}
};
</script>
